import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core';
import { TuiActiveZone, TuiObscured } from '@taiga-ui/cdk';
import { TuiButton, TuiDataList, TuiDropdown, TuiScrollbar, TuiTitle } from '@taiga-ui/core';
import { TuiChevron, TuiFade } from '@taiga-ui/kit';
import { NavListItem } from './nav-list-item';

@Component({
  selector: 'pxc-nav-list',
  templateUrl: './nav-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiActiveZone,
    TuiObscured,
    TuiButton,
    TuiChevron,
    TuiDataList,
    TuiDropdown,
    TuiScrollbar,
    TuiTitle,
    TuiFade,
  ],
  // Renders inline (no wrapper box) so the desktop sidebar and the mobile
  // picker become direct flex children of the parent layout.
  host: { class: 'contents' },
})
export class NavListComponent {
  readonly items = input.required<readonly NavListItem[]>();
  readonly selectedIndex = model.required<number>();
  readonly label = input('');

  readonly isOpen = signal(false);

  select(index: number): void {
    this.selectedIndex.set(index);
    this.isOpen.set(false);
  }
}
